import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 09F53FF1-31D7-44CA-A00E-8CDDF55DB716
 * name server-minus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/server-minus.svg
 * tags
 */
export const ServerMinusIcon = createSvgIcon(<><path d="M4,4H20A1,1 0 0,1 21,5V9A1,1 0 0,1 20,10H4A1,1 0 0,1 3,9V5A1,1 0 0,1 4,4M9,8H10V6H9V8M5,6V8H7V6H5M8,16H16V18H8V16Z" /></>, 'ServerMinusIcon');
export default ServerMinusIcon